import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// Components
import { Tabs } from '@beef/ui-kit';

// Constants
import { TABS_ID } from '../../constants';

const tabs = [
  {
    id: '1',
    title: 'Управление номерами',
    url: '/limited-family',
  },
  {
    id: '2',
    title: 'Условия услуги',
    url: '/limited-family/terms',
  },
];

const FamilyTabs = () => {
  const [activeTab, setActiveTab] = useState(TABS_ID.first);
  const history = useHistory();
  const { pathname } = useLocation();

  const handleChange = useCallback((id) => {
    if (id !== activeTab) {
      setActiveTab(id);
      const path = tabs.find((tab) => tab.id === id);
      history.push(path.url);
    }
  }, [activeTab]);

  useEffect(() => {
    const selectedTab = tabs.find((tab) => tab.url === pathname) || {};
    setActiveTab(selectedTab.id || '1');
  }, [pathname]);

  return (
    <Tabs
      isScrollable={false}
      noWrap
      onChange={handleChange}
      selectedTab={activeTab}
      tabs={tabs}
      variant="secondary"
    />
  );
};

export { FamilyTabs };
